import wire from '../wire';

export default wire(
  'new-event',
  ``,
  () => {
    // Migrated to dashboard_vue
    window.location.href = `${window.VUE_DASHBOARD_ROOT}/schedule/broadcast?showBanner=1`;
  },
  'NewEventController'
);



// WEBPACK FOOTER //
// ./app/pages/new-event/_index.js